import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-flight-result-way',
  templateUrl: './flight-result-way.component.html',
  styleUrls: ['./flight-result-way.component.scss']
})
export class FlightResultWayComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
